export default function getNotificationsIds(notifications) {
  return notifications
    .filter(item => item.viewed === '0')
    .map(item => item.id)
    .join(',')
}
